


















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { GamePlayer } from '@/class/gamePlayer'
import { Side } from '@/enum'
import Card from '@/components/Common/Card/Card.vue'
import TargetLine from '@/components/Common/TargetLine.vue'

@Component({
  components: {
    Card,
    TargetLine,
  }
})
export default class CardArea extends Vue {
  @Prop() player!: GamePlayer;
  @Prop() showsRole!: boolean;
  @Prop() showsBulletCount!: boolean;
  @Prop() showsArmorCount!: boolean;
  @Prop() showsStealCount!: boolean;
  @Prop() showsShieldCount!: boolean;
  @Prop() isSelected!: boolean;
  @Prop() showsVotedPlayer!: boolean;
  @Prop() showsSelectedPlayer!: boolean;

  getCardPosition(playerId: string) {
    const element = document.getElementById(`card_area_${playerId}`);
    if (!element) return{x: 0, y: 0};

    const rect = element.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;

    return {x, y}
  }

  get strokeColor() {
    if (!this.showsRole) return "black";

    if (this.player.role.side === Side.mafia || this.player.role.side === Side.mafiaLeader) {
      return "red";
    }

    if (this.player.role.side === Side.outlaw) {
      return "purple"
    }

    if (this.player.role.side === Side.neutrality) {
      return "green"
    }

    return  "yellow"
  }

}
